export const getQueryArguments = (input, doMenuIsOn) => {
  if (!doMenuIsOn) return input
  return { ...input, menuApi: 'DO' }
}
